import type { Router } from "vue-router"
import type { Emitter } from "mitt"
import globalEvents from "@/events/global-events"
import routes from "./router/routes"
import { usePatientConversationPanel } from "./composables/patient-conversation-panel"

export function patientConversationsModule({
  router,
  eventBus
}: {
  router: Router
  eventBus: Emitter<Record<string, unknown>>
}) {
  for (const route of routes) router.addRoute("dashboard", route)

  // The panel state is module-level, so the next account must not inherit an open conversation or draft recipient
  const { closeConversation, closeComposer } = usePatientConversationPanel()
  eventBus.on(globalEvents.LOG_OUT, () => {
    closeConversation()
    closeComposer()
  })
}

// Public entry for other modules (the patient chart, the dashboard layout); nothing else is imported from here.
export { usePatientConversationPanel } from "./composables/patient-conversation-panel"
export type { NewMessageRecipient } from "./composables/patient-conversation-panel"
export {
  useListPatientConversations,
  usePatientConversationConfig,
  type PatientConversationListParams
} from "./composables/patient-conversations"
export { formatMessageTime } from "./utils/patient-conversation-format"
export { conversationAwaitingBadge, conversationStatusBadge, roleLabel } from "./constants/patient-conversation-labels"
export { default as PatientConversationOverlays } from "./components/thread/PatientConversationOverlays.vue"
